import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

export default function ProductCategoriesSection() {
  const categories = [
  {
    id: 'cat_cooking_oils',
    title: 'Cooking Oils',
    description: 'Premium sunflower, canola, palm, soybean, and olive oils. Perfect for food manufacturers and distributors who need consistent quality in bulk.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b8b90e02-1767663906300.png",
    alt: 'Various cooking oil bottles arranged showing different oil types',
    icon: 'BeakerIcon',
    href: '/products#cooking-oils'
  },
  {
    id: 'cat_wood_pellets',
    title: 'Wood Pellets',
    description: 'High-quality biomass pellets for heating. Ideal for industrial facilities and residential systems. Clean burning and eco-friendly.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_150d6ded0-1770939791739.png",
    alt: 'Wood pellets pile showing renewable energy source',
    icon: 'FireIcon',
    href: '/products#wood-pellets'
  },
  {
    id: 'cat_chicken_feed',
    title: 'Chicken Feed',
    description: 'Complete nutrition for layers, broilers, and starters. Organic options available. Trusted by poultry farms across Europe.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bde9b6de-1770207000661.png",
    alt: 'Chicken feed grains close-up showing nutritional quality',
    icon: 'SparklesIcon',
    href: '/products#chicken-feed'
  },
  {
    id: 'cat_fertilizers',
    title: 'Fertilizers',
    description: 'NPK, urea, phosphate, and organic fertilizers. Boost your crop yields with our proven formulas. Suitable for all farming operations.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a58f553c-1766332570191.png",
    alt: 'Fertilizer granules in soil showing agricultural nutrients',
    icon: 'HomeModernIcon',
    href: '/products#fertilizers'
  },
  {
    id: 'cat_iron_scraps',
    title: 'Iron Scraps',
    description: 'HMS 1&2, shredded steel, and cast iron scrap. Perfect for recycling industries. Competitive pricing on bulk orders.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c62f4120-1770939794036.png",
    alt: 'Iron scrap metal pieces showing recyclable materials',
    icon: 'CubeIcon',
    href: '/products#iron-scraps'
  }];


  return (
    <section className="py-24 bg-background">
      <div className="max-w-container mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16 reveal">
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary mb-4">
            Our Product Range
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground mb-6">
            Quality Products for Every Industry
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            From food manufacturing to renewable energy, we supply the materials your business needs to thrive.
          </p>
        </div>

        {/* Product Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories.slice(0, 3).map((category, index) =>
          <Link
            key={category.id}
            href={category.href}
            className="group reveal"
            style={{ transitionDelay: `${index * 100}ms` }}>
            
              <div className="bg-card rounded-organic overflow-hidden shadow-sm hover-lift h-full">
                {/* Image */}
                <div className="relative h-64 overflow-hidden">
                  <AppImage
                  src={category.image}
                  alt={category.alt}
                  className="w-full h-full object-cover image-scale" />
                
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  
                  {/* Icon Badge */}
                  <div className="absolute top-4 left-4 w-12 h-12 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center">
                    <Icon name={category.icon as any} size={24} className="text-primary" />
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-xl font-bold font-serif text-foreground mb-2 group-hover:text-primary transition-colors">
                    {category.title}
                  </h3>
                  <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
                    {category.description}
                  </p>
                  <div className="inline-flex items-center gap-2 text-sm font-semibold text-primary">
                    Explore Products
                    <Icon name="ArrowRightIcon" size={16} className="arrow-shift" />
                  </div>
                </div>
              </div>
            </Link>
          )}

          {categories.slice(3).map((category, index) =>
          <Link
            key={category.id}
            href={category.href}
            className="group reveal"
            style={{ transitionDelay: `${(index + 3) * 100}ms` }}>
            
              <div className="bg-card rounded-organic overflow-hidden shadow-sm hover-lift h-full">
                <div className="relative h-64 overflow-hidden">
                  <AppImage
                  src={category.image}
                  alt={category.alt}
                  className="w-full h-full object-cover image-scale" />
                
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  
                  <div className="absolute top-4 left-4 w-12 h-12 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center">
                    <Icon name={category.icon as any} size={24} className="text-primary" />
                  </div>
                </div>

                <div className="p-6">
                  <h3 className="text-xl font-bold font-serif text-foreground mb-2 group-hover:text-primary transition-colors">
                    {category.title}
                  </h3>
                  <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
                    {category.description}
                  </p>
                  <div className="inline-flex items-center gap-2 text-sm font-semibold text-primary">
                    Explore Products
                    <Icon name="ArrowRightIcon" size={16} className="arrow-shift" />
                  </div>
                </div>
              </div>
            </Link>
          )}
        </div>
      </div>
    </section>);

}